<template>
  <div class="flex flex-col px-4 h-[80vh]">
    <div
      v-if="htmlContent"
      v-html="htmlContent"
      class="overflow-y-auto flex-1 w-full min-h-0"></div>

    <div v-if="!htmlContent">
      {{ $t('messages.errors.missingFinancialInfo') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCustomerHtmlTabs, getTraderSitesWithConditions } from '@/services/api/traders';
import type { Customer } from '@/types/Traders';
import { onMounted, ref } from 'vue';

const props = defineProps<{
  customer: Customer;
  mode: 'view' | 'edit';
}>();

const htmlContent = ref<string | null>(null);

onMounted(async () => {
  if (props.mode == 'view' && props.customer.boid) {
    let traderSiteBoid: string | undefined = props.customer.defaultTraderSite?.boid;

    if (!traderSiteBoid) {
      const sites = await getTraderSitesWithConditions({
        traderId: props.customer.traderId,
        isActive: true,
      });
      const siteArray = (Array.isArray(sites) ? sites : sites.data) as Array<{
        boid?: string;
        isHq?: boolean;
      }>;
      const selectedSite = siteArray.find((s) => s.isHq) ?? siteArray[0];
      traderSiteBoid = selectedSite?.boid;
    }

    const htmlTabs = await getCustomerHtmlTabs({
      enumValue: 19,
      customerBoid: props.customer.boid,
      traderSiteBoid,
    });

    if (htmlTabs) {
      htmlContent.value = htmlTabs;
    }
  }
});
</script>
